export const organizationQueryKeys = {
  all: [{ entity: "organizations" }],
  list: (): [Record<string, string>] => [{ ...organizationQueryKeys.all[0], scope: "list" }],
};
